// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"4377b7c0","724":"1bbca752","728":"35ae53ac"}[chunkId] + ".chunk.css";
};